/**
 * 設定 bundle 載入完成旗標
 */
export const installBundleReadyRuntime = (): void => {
    window.__GH_COMPONENTS_BUNDLE_READY__ = true;
};
